import {RequestState} from "modules/enums";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getLeaguesStore = (store: IStore) => store.leagues;

export const isLeagueRequested = createSelector(
	[getLeaguesStore],
	(store) => store.requestState === RequestState.Requested
);

export const isLeagueRequestError = createSelector(
	[getLeaguesStore],
	(store) => store.requestState === RequestState.Error
);

// const dummyLeague = {
// 	id: 1,
// 	code: 'asd',
// 	name: 'asd',
// 	user: 123,
// 	privacy: 'private',
// 	class: 'regular',
// 	numTeams: 10,
// 	isJoined: true,
// };

export const getCurrentLeague = createSelector([getLeaguesStore], (store) => store.currentLeague);

export const getCurrentLeagueError = createSelector(
	[getLeaguesStore],
	(store) => store.currentLeagueError
);

export const getMyLeagues = createSelector([getLeaguesStore], (store) => store.leaguesList);

export const getLeaguesToJoin = createSelector(
	[getLeaguesStore],
	(store) => store.leaguesToJoinList
);

export const getLeagueUsers = createSelector([getLeaguesStore], (store) => store.leagueUsers);
